import { TopN } from '../../components/TopN'
import { ColumnComponent } from '../../table_component'

export const seasonalityData: { note: string }[] = [
  {
    note: `
    Check if there exists some periodical pattern, e.g. Every 10mins, or per hour, per day interval. Can start from Performance Overview or any other Top panel.<br />
    <br />
    The workload pattern is:<br />
    <br />
    `
  }
]

interface QPSData {
  qps_type: string
  mean: string | ColumnComponent
  std: string | ColumnComponent
}

export const qpsData: QPSData[] = [
  {
    qps_type: 'QPS(total)',
    mean: 'QPS:total.values.mean',
    std: 'QPS:total.values.std'
  },
  {
    qps_type: 'QPS by SQL Type(Top 5)',
    mean: { __component__: TopN(5, 'QPS:by_type') },
    std: { __component__: TopN(5, 'QPS:by_type') }
  }
]

interface ClientRequestData {
  request_type: string
  mean: string | ColumnComponent
  std: string | ColumnComponent
}

export const clientReqeustData: ClientRequestData[] = [
  {
    request_type: 'KV Request Total',
    mean: 'KV_Request_OPS:total.values.mean',
    std: 'KV_Request_OPS:total.values.std'
  },
  {
    request_type: 'TSO - Command',
    mean: 'KV_Request_OPS_tso_command:total.values.mean',
    std: 'KV_Request_OPS_tso_command:total.values.std'
  },
  {
    request_type: 'TSO - Request',
    mean: 'TSO_request_OPS:total.values.mean',
    std: 'TSO_request_OPS:total.values.std'
  },
  {
    request_type: 'KV Request OPS Client by SQL Type(Top 5)',
    mean: { __component__: TopN(5, 'KV_Request_OPS_Client:by_type') },
    std: { __component__: TopN(5, 'KV_Request_OPS_Client:by_type') }
  }
]

interface TiKVRequestData {
  request_type: string
  mean: string | ColumnComponent
  std: string | ColumnComponent
}

export const tikvRequestData: TiKVRequestData[] = [
  {
    request_type: 'gRPC(total)',
    mean: 'gRPC:total.values.mean',
    std: 'gRPC:total.values.std'
  },
  {
    request_type: 'QPS by SQL Type(Top 5)',
    mean: { __component__: TopN(5, 'grpc_request:by_type') },
    std: { __component__: TopN(5, 'grpc_request:by_type') }
  }
]

interface CPSData {
  cps_type: string
  mean: string | ColumnComponent
  std: string | ColumnComponent
}

export const cpsData: CPSData[] = [
  {
    cps_type: 'CPS Stmt Type(Top 5)',
    mean: { __component__: TopN(5, 'CPS_stmt:by_type') },
    std: { __component__: TopN(5, 'CPS_stmt:by_type') }
  }
]

interface ProfileOthersData {
  name: string
  mean: string
  std: string
  location: string
}

export const profileOthersData: ProfileOthersData[] = [
  {
    name: 'Failed Query OPM Detail(total_for_all_types)',
    mean: 'QPS_failed:total.values.mean',
    std: 'QPS_failed:total.values.std',
    location: 'TiDB-Details --> Query Details --> Failed Query OPM Detail'
  },
  {
    name: 'Expensive Executors OPS(total_for_all_types)',
    mean: 'expensive_executor_OPS:total.values.mean',
    std: 'expensive_executor_OPS:total.values.std',
    location: 'TiDB-Details --> Executor --> Expensive Executors OPS'
  }
]

export const backgroundEventData: { note: string }[] = [
  {
    note: `All below mentied “Impact to top level's Duration and QPS ”, means the correlation between the items' primary indicator and below system's primary indicator :<br />
    - TiDB-Details --> Query Summary --> QPS(total)<br />
    - TiDB-Details --> Query Summary --> Duration（P99)<br />
    The general expectation is <5%`
  }
]
